import React from 'react';
import classnames from 'classnames';

type Props = {
    reversed?: boolean;
    title: string | React.ReactNode;
    content: string | React.ReactNode;
    imageURL: string;
    isVideo?: boolean;
};

const FityFifty: React.FC<Props> = ({
    reversed,
    imageURL,
    title,
    content,
    isVideo,
}: Props) => {
    const getImage = () => {
        if (!isVideo) {
            return (
                <div
                    className="h-full w-full bg-cover bg-no-repeat bg-center"
                    style={{
                        backgroundImage: `url(${imageURL})`,
                    }}
                ></div>
            );
        }

        return (
            <video
                className="h-full w-full object-cover object-left-bottom"
                autoPlay
                muted
                loop
                playsInline
            >
                <source src={imageURL} type="video/mp4" />
            </video>
        );
    };

    return (
        <div
            className={classnames(
                'w-full h:auto m:h-fifty-fifty-container m:flex items-center text-calcite-text-2',
                { 'flex-row-reverse': reversed }
            )}
        >
            <div className="relative w-full m:w-1/2 h-60 m:h-full bg-black">
                {getImage()}
            </div>

            <div className="m:w-1/2 m:h-full bg-calcite-foreground-2 flex items-center">
                <div className="w-4/5 ml-12 py-10">
                    <h1 className="text-4xl font-light">{title}</h1>

                    <div className="h-divider"></div>

                    {content}
                </div>
            </div>
        </div>
    );
};

export default FityFifty;
